import React from 'react';
import { Package } from 'lucide-react';

export const CategoryCard = ({ category, onClick }) => {
  return (
    <div
      onClick={() => onClick(category)}
      className="aspect-square rounded-2xl bg-white border-4 border-slate-100 shadow-md hover:border-[#00C2CB] hover:shadow-xl transition-all duration-300 flex flex-col overflow-hidden group cursor-pointer relative"
      data-testid={`category-card-${category.id}`}
    >
      <div className="flex-1 w-full relative overflow-hidden bg-slate-50">
        {category.imageUrl ? (
          <img 
            src={category.imageUrl} 
            alt={category.name} 
            className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-slate-300 group-hover:text-[#00C2CB] transition-colors duration-300">
            <Package className="w-16 h-16" />
          </div>
        )}
        {/* Overlay gradient for text readability if needed, though we will put text in a block below */}
      </div>
      
      <div className="bg-white py-4 px-3 flex items-center justify-center border-t border-slate-100 group-hover:bg-[#00C2CB] transition-colors duration-300">
        <h3 className="font-fredoka font-bold text-lg text-[#1A1A2E] group-hover:text-white text-center transition-colors duration-300 line-clamp-1" data-testid={`category-name-${category.id}`}>
          {category.name}
        </h3>
      </div>
    </div>
  );
};